import { CatalogueService } from 'src/app/angularJS/services/catalogue/catalogue.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';

export class CatalogueEditController {

  public static $inject = [
    '$state',
    '$stateParams',
    'catalogueService',
    'ACTToolbarService',
    'UserMessages'
  ];

  public date: Date;
  public time: string;
  public selectedScheme: InterACT.Interfaces.Schemes.Scheme;
  public editableCatalogue: InterACT.Interfaces.Catalogues.Catalogue;
  public catalogue: InterACT.Interfaces.Catalogues.Catalogue;

  constructor(
    private $state: ng.ui.IStateService,
    $stateParams,
    private catalogueService: CatalogueService,
    private ActToolbarService: ACTToolbarService,
    private UserMessages: UserMessagesService
  ) {
    this.catalogue = <any>{};
    this.editableCatalogue = $stateParams.sourceCatalogue;
    this.time = <any>moment(this.editableCatalogue.effectiveFrom).format('HH:mm');
    this.date = new Date(moment(this.editableCatalogue.effectiveFrom).format('YYYY-MM-DD'));
    this.activate();
  }

  public editCatalogue = () => {
    const dateTime = this.date;
    if (this.time) {
      const time = this.time.split(':');
      dateTime.setHours(parseInt(time[0], 10), parseInt(time[1], 10));
    }
    this.catalogue.effectiveFrom = <any>(moment(dateTime).utc().format('YYYY-MM-DDTHH:mm') + 'Z');

    return this.catalogueService.edit(this.editableCatalogue.id, this.catalogue)
      .then(() => {
        this.UserMessages.showToast('TOAST_MESSAGE.CATALOGUE.EDITED');
        return this.exitEditCatalogue();
      });
  }

  public exitEditCatalogue = () => this.$state.go('catalogues.list');

  private activate() {
    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('CATALOGUES');
    });
  }
}